import { Component, OnInit } from '@angular/core';
import { HelperService } from 'src/services/helperService';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.sass'],
    standalone: false
})
export class LoginComponent implements OnInit {
  ssoSignOnUrl = "PingId/Sso/InitiateSingleSignOn";
  constructor(public helperService: HelperService) { }

  ngOnInit(): void {
  }
  onClick() {    
  }

}
